<script setup>
import {defineEmits, defineProps, onMounted, ref} from "vue";
import axiosApi from "@/utils/axiosApi";
import {ElMessage} from "element-plus";
import Forgot from "@/components/login/forgot.vue";

const emit = defineEmits(['login'])
const prop = defineProps(['account'])
const sms = ref()
const loginLoading = ref(false)
const form = ref({
  account: "",
  password: "",
  type: "scal",
  login_type: "1",
  sms_text: ""
})
const rule = {
  account: [
    {required: true, message: "请输入川航会员手机号/会员卡号/证件号"}
  ],
  password: [{required: true, message: "请输入密码"}]
}
onMounted(() => {
  if (prop.account) {
    form.value.account = prop.account
  }
})
const loginFn = (refs) => {
  refs.validate(err => {
    loginLoading.value = err
    if (err) {
      new axiosApi({
        encode: "site",
        method: "user/login",
        body: form.value
      }).send((res) => {
        loginLoading.value = false
        emit("login", res)
      }, () => {
        loginLoading.value = false
        ElMessage.error({message: "登录异常"})
      })
    }
  })
}
</script>

<template>
  <el-form ref="sms" class="login-form" size="large" :model="form" :rules="rule">
    <el-form-item prop="account">
      <el-input placeholder="请输入会员手机号/会员卡号/证件号" v-model="form.account" clearable/>
    </el-form-item>
    <el-form-item prop="password">
      <el-input placeholder="请输入密码" type="password" v-model="form.password" clearable/>
    </el-form-item>
  </el-form>
  <forgot/>
  <div class="button">
    <el-button type="danger" round size="large" :loading="loginLoading" @click="loginFn(sms)">立即登录</el-button>
  </div>
</template>

<style scoped lang="less">
/deep/ .el-input{
  .el-input__wrapper{
    padding: 5px 10px;
    background-color: #e5e5e5;
    box-shadow: none;
  }
}
</style>
